import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import {
  CategoriaService,
  Categoria,
} from '../../services/categoria/categoria.service';
import { HttpErrorResponse } from '@angular/common/http';
import { resolveIdCategoriaPaiFinalidade } from '../../utils/categoria-finalidade.util';

@Component({
  selector: 'app-categoria',
  templateUrl: './categoria.component.html',
  styleUrls: ['./categoria.component.css'],
})
export class CategoriaComponent implements OnInit {
  categoriaForm!: FormGroup;
  categorias: Categoria[] = [];
  isEditMode = false;
  currentCategoriaId: number | null = null;
  displayEditModal: boolean = false;
  idPaiFinalidade: number | null = null;

  constructor(
    private fb: FormBuilder,
    private categoriaService: CategoriaService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {

    this.categoriaForm = this.fb.group({
      categoria_descricao: ['', Validators.required],
      status: ['A', Validators.required],
    });
    this.recarregarListaFinalidades();
  }

  /** Lista apenas categorias filhas do nó pai cuja descrição é "Finalidade". */
  recarregarListaFinalidades(): void {
    this.categoriaService.listarCategorias().subscribe({
      next: (todas) => {
        this.idPaiFinalidade = resolveIdCategoriaPaiFinalidade(todas);
        if (this.idPaiFinalidade === null) {
          this.categorias = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail:
              'Categoria pai "Finalidade" não encontrada na base. Cadastro de finalidades indisponível.',
          });
          return;
        }
        this.categorias = todas.filter(
          (c) => String(c.categoria_pai) === String(this.idPaiFinalidade)
        );
      },
      error: (err) => console.error('Erro ao carregar categorias', err),
    });
  }


  salvarCategoria(): void {
    if (this.categoriaForm.invalid) {
      return;
    }
    if (this.idPaiFinalidade === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail:
          'Categoria pai "Finalidade" não encontrada. Não é possível salvar.',
      });
      return;
    }
    const formValue = this.categoriaForm.value;
    const categoria: Categoria = {
      categoria_descricao: formValue.categoria_descricao,
      status: formValue.status,
      categoria_pai: String(this.idPaiFinalidade),
    };

    if (this.isEditMode && this.currentCategoriaId !== null) {
      this.categoriaService
        .editarCategoria(this.currentCategoriaId, categoria)
        .subscribe({
          next: (data) => {
            this.resetForm();
            this.recarregarListaFinalidades();
          },
          error: (err) => console.error('Erro ao atualizar categoria', err),
        });
    } else {
      this.categoriaService.criarCategoria(categoria).subscribe({
        next: (data) => {
          this.resetForm();
          this.recarregarListaFinalidades();
        },
        error: (err) => console.error('Erro ao criar categoria', err),
      });
    }
  }

 
  abrirModalEdicao(categoria: Categoria): void {
    this.isEditMode = true;
    this.currentCategoriaId = categoria.categoria_id || null;
    this.categoriaForm.patchValue({
      categoria_descricao: categoria.categoria_descricao,
      status: categoria.status, 
    });
    this.displayEditModal = true;
  }


  fecharModal(): void {
    this.displayEditModal = false;
  }

  
  confirmarEdicao(): void {
    if (this.categoriaForm.invalid || this.currentCategoriaId === null) {
      return;
    }
    const formValue = this.categoriaForm.value;
    const categoria: Categoria = {
      categoria_descricao: formValue.categoria_descricao,
      status: formValue.status, 
    };
    this.categoriaService
      .editarCategoria(this.currentCategoriaId, categoria)
      .subscribe({
        next: (data) => {
          this.resetForm();
          this.recarregarListaFinalidades();
          this.displayEditModal = false;
        },
        error: (err) => console.error('Erro ao atualizar categoria', err),
      });
  }

  
  resetForm(): void {
    this.isEditMode = false;
    this.currentCategoriaId = null;
    this.categoriaForm.reset({
      categoria_descricao: '',
      status: 'A',
    });
  }

  
  excluirCategoria(id: number): void {
  this.categoriaService.excluirCategoria(id).subscribe({
    next: () => {
      this.messageService.add({
        severity: 'success',
        summary: 'Sucesso',
        detail: 'Categoria desativada com sucesso',
      });
      this.recarregarListaFinalidades();
    },
    error: (err: HttpErrorResponse) => {
      if (err.status === 412) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Não permitido',
          detail: 'Não foi possível desativar: finalidade ainda vinculada a prompts.',
        });
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Não foi possível desativar, tente novamente mais tarde.',
        });
      }
    }
  });
}
}
